import { Module } from 'wrapper6'
import Modalbox from '../utils/_modal-box'

const $ = jQuery

export default class ModalBox extends Module {
  ready (app) {
    new Modalbox('.play-btn')
  }
}
